import store from '../../../../store'
import os_skd from './os_skd.vue';

window.os_inside_skd =  new Vue({
    store,
    name : "os_inside_skd",
    el: '#os_inside_skd',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },
    components : {
        os_skd
    }
});
